
import { Button } from "@/components/ui/button";
import { TrendingUp, Shield } from "lucide-react";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="relative py-20 px-4 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"></div>
      <div className="absolute inset-0 bg-black bg-opacity-20"></div>
      
      <div className="relative max-w-7xl mx-auto text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
          Real Estate's
          <span className="text-yellow-700"> Best Kept Secret</span>
        </h1>
        <p className="text-xl md:text-2xl mb-8 text-slate-100 max-w-4xl mx-auto">
          Exclusive land contracts and private mortgages for qualified investors 
          seeking high-yield real estate investment opportunities.
        </p>
        
        <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
          <Link to="/investor-portal">
            <Button size="lg" className="bg-white text-slate-900 hover:bg-gray-100 px-8 py-4 text-lg font-semibold">
              <Shield className="mr-2 h-5 w-5" />
              Access Investor Portal
            </Button>
          </Link>
          <Button 
            size="lg" 
            variant="outline" 
            className="border-yellow-700 text-yellow-700 hover:bg-yellow-700 hover:text-slate-900 px-8 py-4 text-lg font-semibold"
            disabled
          >
            <TrendingUp className="mr-2 h-5 w-5" />
            Invite Only Access
          </Button>
        </div>
        
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div className="bg-white bg-opacity-10 rounded-lg p-6 backdrop-blur-sm">
            <div className="text-3xl font-bold text-yellow-700 mb-2">Curated</div>
            <div className="text-slate-100">Investment Portfolio</div>
          </div>
          <div className="bg-white bg-opacity-10 rounded-lg p-6 backdrop-blur-sm">
            <div className="text-3xl font-bold text-yellow-700 mb-2">High-Yield</div>
            <div className="text-slate-100">Return Opportunities</div>
          </div>
          <div className="bg-white bg-opacity-10 rounded-lg p-6 backdrop-blur-sm">
            <div className="text-3xl font-bold text-yellow-700 mb-2">Exclusive</div>
            <div className="text-slate-100">Investor Network</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
